import styled from '~/utils/styled';
// ---- external imports ----

import Asset from '~/containers/GameAsset';
import {
	FORM_WIDTH_PROJECTION,
	PrimaryButton,
	createPrimaryButtonText
} from '~/authentication/AuthAssets';
// ---- internal imports ----


// region [Projection Constants]
export const INPUT_PROJECTION = { width: 632, height: 76 };
const RESET_BTN_TEXT_PROJECTION = { width: 68 };
// endregion

// region [Components]

export const StatusText = styled(Asset.Text.withProps({
	fontSize: 24,
	projection: FORM_WIDTH_PROJECTION,
}))`
	font-family: "NotoSans";
	color: #fff5b0;
	text-align: center;
`;

export const BackToLoginLink = styled(Asset.Link.withProps({
	fontSize: 24,
	projection: FORM_WIDTH_PROJECTION,
}))`
	font-family: "NotoSans ExtraBold";
	color: #72250c;
	text-align: left;
	text-decoration: none;
`;

export const ResetButton = PrimaryButton;

export const ResetButtonText = createPrimaryButtonText(RESET_BTN_TEXT_PROJECTION);

// endregion
